import { render, staticRenderFns } from "./MdfeRequests.vue?vue&type=template&id=bc38a81c&scoped=true"
import script from "./MdfeRequests.vue?vue&type=script&lang=js"
export * from "./MdfeRequests.vue?vue&type=script&lang=js"
import style0 from "./MdfeRequests.vue?vue&type=style&index=0&id=bc38a81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc38a81c",
  null
  
)

export default component.exports